import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import CriteriaCheckboxComponent from '../../components/criteria/CriteriaCheckboxComponent';
import Constants from '../../utils/constants';
import NotificationService from '../../services/NotificationService';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Menu } from 'primereact';

class PushMessagesListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new NotificationService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            renderDialog: false,
            eventDetails: undefined,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            showConfirmRemoveDialog: false,
        };

        this.service = new NotificationService();
        this.handleChooseExpiredNotifications = this.handleChooseExpiredNotifications.bind(this);
    }

    updateSearchCriteria(criteria) {
        return {
            locale: this.authService.getProfile().locale,
            hideExpired: criteria.hideExpired,
            title: criteria.title,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            locale: this.authService.getProfile().locale,
            hideExpired: false,
            title: '',
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: false,
        };
    }

    initializeFromBackend() {}

    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'pushMsg.listTitle';
    }
    getCriteriaName() {
        return 'pushMsg-list-sc';
    }

    getContainerListName() {
        return 'pushMsg-list-container';
    }
    renderCriteria() {
        return (
            <div>
                <div className='row'>
                    <CriteriaTextComponent
                        id='text-sc'
                        name='title'
                        label={t('pushMsg.title')}
                        colClass='col-lg-4 col-sm-6'
                        value={this.state.criteria.title}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                    <CriteriaCheckboxComponent
                        id='checkbox-sc'
                        label={t('pushMsg.hideExpired')}
                        name='showExpired'
                        onChange={this.handleChooseExpiredNotifications}
                        value={this.state.criteria.hideExpired}
                        colClass='col-lg-4 col-sm-6'
                        checked={this.state.criteria.hideExpired}
                    />
                </div>
            </div>
        );
    }

    handleChooseExpiredNotifications(a, b, c) {
        const check = c.checked;
        this.setState((a) => ({
            criteria: {
                ...a.criteria,
                hideExpired: check,
            },
        }));
    }

    prepareHeaderItems() {
        const {t, newUrl} = this.props;
        const href = `${newUrl}/`+sessionStorage.getItem('i18nextLng');
        return this.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR')
            ? [
                  {
                      label: t('pushMsg.addButton'),
                      onClick: () => {
                          //   window.location.href = AppPrefixUtils.locationHrefUrl(href);
                          this.props.history.push(AppPrefixUtils.locationHrefUrl(href));
                      },
                      type: 'BUTTON',
                      className: 'float-left',
                      variant: 'white',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }

    prepareColumns() {
        return [
            {field: 'id', header: 'ID', sortable: true, width: '90px'},
            {field: 'status', header: t('pushMsg.status'), sortable: true, width: '90px'},
            {field: 'title', header: t('pushMsg.title'), sortable: false},
            {
                field: 'publishDate',
                header: t('pushMsg.publishDate'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'publishDate', Constants.DATE_TIME_FORMAT),
            },
            {field: 'action', header: t('global.action'), body: this.actionTemplate, float: 'center'},
        ];
    }

    handleGoBack(e) {
        e.preventDefault();
        this.blockUi();
        const {backUrl} = this.props;
        // window.location.href = AppPrefixUtils.locationHrefUrl(backUrl);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderDialog() {
        return null;
    }

    actionTemplate(rowData) {
         const menuRef = React.createRef();
        const { detailUrl } = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/` + sessionStorage.getItem('i18nextLng');
    
        const menuItems = [
            {
                label: t('global.details'),
                icon: 'pi pi-eye',
                command: () => this.handleGoToDetail(detailHref),
            }
        ];
    
        return (
            <div>
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="menu-items"
                    onClick={(event) => menuRef.current.toggle(event)}
                />
            </div>
        );
    }

   
    breadCrumbItems() {
        return [{name: t('pushMsg.name'), url: '/pushMsg-list'}];
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

PushMessagesListContainer.defaultProps = {
    detailUrl: '/pushMsg/details',
    newUrl: '/pushMsg/create',
    editUrl: '/pushMsg/edit',
    lazy: true,
    renderChangeLanguegeFilter: true,
};

PushMessagesListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(PushMessagesListContainer));
